export default "__VITE_ASSET__f45ae53a__"